export default "__VITE_ASSET__Bkmhmk9t__"